import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

interface BackHandlerOptions {
  isModalOrSheetOpen: boolean;
  onCloseModalOrSheet: () => void;
  view: string;
  onGoHome: () => void;
  onDeepLink?: (url: string) => void;
}

/**
 * Hook to manage native Android hardware / gesture back button navigation
 * and external deep links via Capacitor App plugin.
 */
export function useAndroidBackHandler({
  isModalOrSheetOpen,
  onCloseModalOrSheet,
  view,
  onGoHome,
  onDeepLink,
}: BackHandlerOptions) {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const backListenerPromise = App.addListener('backButton', () => {
      if (isModalOrSheetOpen) {
        onCloseModalOrSheet();
      } else if (view !== 'live') {
        onGoHome();
      } else {
        App.exitApp();
      }
    });

    const urlListenerPromise = App.addListener('appUrlOpen', (data) => {
      if (onDeepLink && data.url) {
        onDeepLink(data.url);
      }
    });

    return () => {
      backListenerPromise.then((handle) => handle.remove());
      urlListenerPromise.then((handle) => handle.remove());
    };
  }, [isModalOrSheetOpen, onCloseModalOrSheet, view, onGoHome, onDeepLink]);
}
